
export const Gutter = ({ right = false, icon = false, children }: { right?: boolean, icon?: boolean, children?: React.ReactNode }) => (
  <div
    className={right ? 'ms-3' : 'me-3' + (icon ? ' bg-primary rounded-circle d-flex align-items-center justify-content-center' : '')}
    style={{ width: '32px', minWidth: '32px', height: '32px', marginTop: '1rem' }}
  >{children}</div>
);
